<template>
  <error-page-content
    :title="$t('errors.pageNotFound')"
    error-code="not_found"
    :status="404"
  >
    <template #icon>🤷‍♂️</template>
  </error-page-content>
</template>

<script setup lang="ts">
import ErrorPageContent from "@core/errors/ErrorPageContent.vue";
</script>

<style></style>
